import { Box, SectionHelper, Transition } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
const GreenStatusCompleteFilledSmallIcon = /*#__PURE__*/React.createElement(Box, {
  color: "G10"
}, /*#__PURE__*/React.createElement(StatusCompleteFilledSmall, null));
export const PopUpNotification = _ref => {
  let {
    message,
    onClose,
    skin,
    prefixIcon = GreenStatusCompleteFilledSmallIcon
  } = _ref;
  return /*#__PURE__*/React.createElement(Transition, {
    animateOnLoad: true,
    enterAnimation: {
      moveIn: {
        direction: 'bottomToTop',
        distance: '20px',
        duration: 'slow01',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    borderRadius: "6px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    layout: "horizontal",
    prefixIcon: prefixIcon,
    size: "small",
    skin: skin,
    showCloseButton: true,
    showPrefixIcon: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Box, {
    paddingRight: "SP3"
  }, message))));
};
//# sourceMappingURL=pop-up-notification.js.map